import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { BREAKPOINTS } from '@src/js/constants.js';
import DirectionsService from '@src/js/services/directions-service.js';
import SearchApiService from '@src/js/services/search-api-service.js';
import GeolocationService from '@src/js/services/geolocation-service.js';
import ProviderResults from '@src/components/providers-results/provider-results.jsx';
import { LuminisServiceUtils } from '@js/utils/utils-imports.es6.js';
import { DependenciesProvider } from '@src/contexts/dependencies.jsx';

export default class ProvidersResultsContainer {
  constructor() {
    this.providerResultsContainer = document.querySelector('.find-a-provider-results--container');
    if (!this.providerResultsContainer) {
      return;
    }

    this.searchApiService = new SearchApiService();
    this.geolocationService = new GeolocationService();

    this.luminisServiceUtils = new LuminisServiceUtils();

    this.siteHeader = document.querySelector('.site-header__inner__container');

    this.providersResultsWrapper = document.querySelector('.provider-results-grid--wrapper');
    this.hideMapButton = this.providersResultsWrapper.querySelector('.hide-map-button');
    this.showMapButton = this.providersResultsWrapper.querySelector('.show-map-button');

    this.setListeners();
    this.setLeftMargin();

    this.updateContainer();
  }

  onShowMap() {
    this.providersResultsWrapper.classList.remove('no-map');
    this.setLeftMargin();
  }

  onHideMap() {
    this.providersResultsWrapper.classList.add('no-map');
    this.providersResultsWrapper.style.removeProperty('margin-left');
  }

  setListeners() {
    window.addEventListener('resize', () => {
      this.setLeftMargin();
    });
    this.hideMapButton.addEventListener('click', () => {
      this.onHideMap();
    });
    this.showMapButton.addEventListener('click', () => {
      this.onShowMap();
    });
  }

  setLeftMargin() {
    if (window.innerWidth >= BREAKPOINTS.DESKTOP && !this.providersResultsWrapper.classList.contains('no-map')) {
      const amountHeaderIsFromLeftOfWindow = this.siteHeader.getBoundingClientRect().left;
      this.providersResultsWrapper.style.marginLeft = `${amountHeaderIsFromLeftOfWindow}px`;
    } else {
      this.providersResultsWrapper.style.removeProperty('margin-left');
    }
  }

  openDirections(address) {
    const directionsService = new DirectionsService();
    directionsService.openDirections(address);
  }

  updateContainer() {
    ReactDOM.render(
      <BrowserRouter>
        <DependenciesProvider
          geolocationService={this.geolocationService}
          luminisServiceUtils={this.luminisServiceUtils}
          searchApiService={this.searchApiService}
        >
          <ProviderResults />
        </DependenciesProvider>
      </BrowserRouter>,
      this.providerResultsContainer
    );
  }
}
